import gql from "graphql-tag";

export const mutation_setUserMarketingProfile = gql`
  mutation ($profile: Map) {
    SetUserMarketingProfile(input: { profile: $profile }) {
      success
    }
  }
`;
